import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import AuthForm from '../components/AuthForm';

const AuthPage = ({ setUser }) => {
  const [isLoginMode, setIsLoginMode] = useState(true);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();
  const isMounted = useRef(true);

  // Включаем поддержку кук по умолчанию
  axios.defaults.withCredentials = true;

  useEffect(() => {
    isMounted.current = true;

    const checkAuth = async () => {
      try {
        const token = localStorage.getItem('token');
        if (token) {
          const response = await axios.get('/api/auth/me', {
            headers: {
              Authorization: `Bearer ${token}`
            }
          });

          const role = response.data.role;
          if (role === 'admin') {
            navigate('/admin-account');
          } else {
            navigate('/account');
          }
          setIsAuthenticated(true);
        }
      } catch (error) {
        console.error('Ошибка проверки авторизации:', error);
        localStorage.removeItem('token');
        setIsAuthenticated(false);
      }
    };

    if (!isAuthenticated) {
      checkAuth();
    }

    return () => {
      isMounted.current = false;
    };
  }, [navigate, isAuthenticated]);

  const handleAuth = async (credentials) => {
    setLoading(true);
    setError(null);
    try {
      const url = isLoginMode ? '/api/auth/login' : '/api/auth/register';
      
      const response = await axios.post(url, credentials);

      const token = response.data.token;
      if (token) {
        localStorage.setItem('token', token);
      }

      const userResponse = await axios.get('/api/auth/me', {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      const user = userResponse.data;
      localStorage.setItem('user', JSON.stringify(user));

      if (isMounted.current) {
        setUser(user);
      }

      navigate(user.role === 'admin' ? '/admin-account' : '/account');
    } catch (err) {
      console.error('Ошибка авторизации:', err);
      if (isMounted.current) {
        setError('Неверный email или пароль или ошибка регистрации');
      }
    } finally {
      if (isMounted.current) {
        setLoading(false);
      }
    }
  };

  return (
    <div className='boxAuth'>
      <h1>{isLoginMode ? 'Вход' : 'Регистрация'}</h1>
      <AuthForm
        isLoginMode={isLoginMode}
        onSubmit={handleAuth}
        setUser={setUser}
      />
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <button
        className="glow-on-hover2"
        onClick={() => setIsLoginMode(!isLoginMode)}
        disabled={loading}
      >
        {isLoginMode ? 'Переключиться на регистрацию' : 'Переключиться на вход'}
      </button>
      {loading && <p>Загрузка...</p>}
    </div>
  );
};

export default AuthPage;
